import { render, staticRenderFns } from "./CardNotTicket.vue?vue&type=template&id=d8f083c6"
import script from "./CardNotTicket.vue?vue&type=script&lang=ts"
export * from "./CardNotTicket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports